import SealList from 'components/SealList/SealList.vue'
import AmountCompanyCountry from '@/mixins/amount-company-country'
import { RENTALS_CODE } from 'config/rentals'
import { mapGetters } from 'vuex'

export default {
  name: 'AppLoadPage',

  mixins: [AmountCompanyCountry],

  props: {
    title: {
      required: true,
      type: String
    },
    showTopicsList: {
      required: false,
      type: Boolean,
      default: false
    },
    showCar: {
      required: false,
      type: Boolean,
      default: false
    },
    rentals: {
      required: false,
      type: Array,
      default: () => []
    }
  },

  components: {
    SealList
  },

  data() {
    return {
      messages: []
    }
  },

  async mounted() {
    if (await this.$store.getters.getIsBrazilianCode) {
      this.messages = [
        this.$t('loading.messages.brazilian.1', this.getCountryAmount()),
        this.$t('loading.messages.brazilian.2', this.getCountryAmount()),
        this.$t('loading.messages.brazilian.3')
      ]
    } else {
      this.messages = [
        this.$t('loading.messages.otherResidenceCountry.1', this.getCountryAmount()),
        this.$t('loading.messages.otherResidenceCountry.2', this.getCountryAmount()),
        this.$t('loading.messages.otherResidenceCountry.3')
      ]
    }
  },

  computed: {
    visibleCompanies() {
      return this.rentals.filter((company) => {
        return company.id !== RENTALS_CODE.OPAQUE
      })
    },
    ...mapGetters({
      showLoading: 'getLoadPage'
    })
  },

  watch: {
    showLoading (nv) {
      if (nv) {
        $('body').css('overflow', 'hidden')
      } else {
        $('body').css('overflow', '')
      }
    }
  }
}
